import { FormControl, FormGroup, Validators } from '@angular/forms';

export class FileContentForm extends FormGroup<{
  id: FormControl<undefined | number>;
  filecontents: FormControl<undefined | string>;
}> {
  constructor() {
    super({
      id: new FormControl<undefined | number>(
        { value: undefined, disabled: false },
        { nonNullable: true }
      ),
      filecontents: new FormControl<undefined | string>(
        { value: undefined, disabled: false },
        { nonNullable: true, validators: [Validators.required] }
      )
    });
  }
}
